import { getCatalogItem } from "./CatalogItemAction";

const dispatchGetCatalogItem = (dispatch: Function) => (filterValues: any) => {
    dispatch(getCatalogItem(filterValues));
};

const CatalogItemDispatch = {
    dispatchGetCatalogItem
};

export default CatalogItemDispatch